<template>
  <v-layout row wrap justify-center>
    <bill-preview v-model="dialog">
      <transfer-bill
        slot="form"
        v-bind="showItem"
        v-if="showItem.transfer.type == 'a2a'"
      />
      <send-transfer-bill
        slot="form"
        v-bind="showItem"
        v-if="showItem.transfer.type == 'send'"
      />
      <receive-transfer-bill
        slot="form"
        v-bind="showItem"
        v-if="showItem.transfer.type == 'receive'"
      />
    </bill-preview>
    <v-card class="shadow flex xs12">
      <v-card-text class="pt-1">
        <div class="flex-row align-center justify-start pt-2">
          <div class="pa-2 mb-2 lable-out" v-if="!accountView">
            <strong class="body-2">{{ $t(label) }}</strong>
          </div>
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            v-if="!dashboardView"
            style="max-width: 400px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            color="grey darken-2"
            class="ml-0"
            flat
            icon
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            color="grey darken-2"
            class="mx-0"
            flat
            icon
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </div>

        <v-data-table
          ref="tbl"
          :search="search"
          :headers="headers"
          :items="computedItems"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ item, index }">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ item.number }}</td>
              <td>{{ item.type }}</td>
              <td @dblclick="$emit('customer_changed', item.customer_id)">{{ item.sender.name }}</td>
              <td>{{ item.receiver.name }}</td>
              <td
                :class="{
                  'red--text': item.amount < 0,
                  'activeColor--text': item.amount > 0,
                }"
              >
                {{ item.amount | currency({ symbol: smbl(item.currency_id) }) }}
              </td>
              <!-- <td>{{ item.rate }}</td>
              <td
                :class="{
                  'red--text': item.exchanged < 0,
                  'activeColor--text': item.exchanged > 0,
                }"
              >
                {{
                  item.exchanged
                    | currency({ symbol: smbl(item.receiver_currency_id) })
                }}
              </td> -->
              <td
                :class="{
                  'red--text': item.commission_amount < 0,
                  'activeColor--text': item.commission_amount > 0,
                }"
              >
                {{
                  item.commission_amount
                    | currency({ symbol: smbl(item.commission_currency_id) })
                }}
              </td>
              <td
                :class="{
                  'red--text': item.paid_commission_amount < 0,
                  'activeColor--text': item.paid_commission_amount > 0,
                }"
              >
                {{
                  item.paid_commission_amount
                    | currency({
                      symbol: smbl(item.paid_commission_currency_id),
                    })
                }}
              </td>
              <td>{{ item.description }}</td>
              <td>{{ item.date | persianDateFilter }}</td>
              <td>{{ item.time | persianDateFilter }}</td>
              <td
                :class="
                  item.done == 1 ? ' green lighten-2' : '  amber lighten-2'
                "
              >
                {{
                  item.done == 1 ? $t("transfer_done") : $t("transfer_not_done")
                }}
              </td>
              <td>
                <v-btn
                  flat
                  icon
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="showTransfer(item)"
                >
                  <v-icon>launch</v-icon>
                </v-btn>
                <!-- <v-btn
                  flat
                  small
                  icon
                  class="ma-0"
                  color="grey darken-1"
                  @click="editItem(item)"
                  v-if="userCan(`edit_${item.type}_transfers`) && item.editable"
                >
                  <v-icon>edit</v-icon>
                </v-btn> -->
                <!-- <v-btn
                  flat
                  icon
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="deleteItem(item)"
                  v-if="userCan(`delete_${item.type}_transfers`) && item.editable"
                >
                  <v-icon>delete_outline</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </template>
          <template slot="footer" v-if="accountView">
            <tr
              class="font-weight-bold"
              v-for="(value, key) in summery.currencies"
              :key="key"
            >
              <td colspan="5">{{ $t("total") }} {{ smbl(value) }}</td>
              <td class="lr--text px-3">
                {{ summery.amount[value] | currency({ symbol: smbl(value) }) }}
              </td>
              <!-- <td>
                {{
                  summery.exchanged[value] | currency({ symbol: smbl(value) })
                }}
              </td> -->
              <td class="lr--text px-3">
                {{
                  summery.commission_amount[value]
                    | currency({ symbol: smbl(value) })
                }}
              </td>
              <td class="lr--text px-3">
                {{
                  summery.paid_commission_amount[value]
                    | currency({ symbol: smbl(value) })
                }}
              </td>
              <td colspan="100%">
                 {{
                  (summery.commission_amount[value] - summery.paid_commission_amount[value])
                    | currency({ symbol: smbl(value) })
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import curjs from 'currency.js'
export default {
  props: {
    date: { default: null },
    initList: {
      default: true,
    },
    accountView: {
      default: false,
    },
    dashboardView: {
      default: false,
    },
    transfers: {
      default: () => [],
    },
    type: { default: "send" },
    label: { default: "transfers" },
  },

  data: () => ({
    items: [],
    search: "",
    showItem: {
      transfer: {},
      receiver: {},
    },
    dialog: false,
  }),
  computed: {
    computedItems: (vm) => (vm.initList ? vm.items : vm.transfers),
    summery() {
      let amount = {};
      let exchanged = {};
      let commission_amount = {};
      let paid_commission_amount = {};
      let currencies = {};

      this.computedItems.forEach((item) => {
        //sum amounts by currency
        if (!amount[item.currency_id]) amount[item.currency_id] = 0;
        amount[item.currency_id] = amount[item.currency_id] + item.amount;

        // sum exchenges by currency
        if (!exchanged[item.receiver_currency_id])
          exchanged[item.receiver_currency_id] = 0;
        exchanged[item.receiver_currency_id] =
          exchanged[item.receiver_currency_id] + item.exchanged;

        //sum amounts by currency
        if (!commission_amount[item.commission_currency_id])
          commission_amount[item.commission_currency_id] = 0;
        commission_amount[item.commission_currency_id] =
          commission_amount[item.commission_currency_id] +
          item.commission_amount;
 

        //sum amounts by currency
        if (!paid_commission_amount[item.paid_commission_currency_id])
          paid_commission_amount[item.paid_commission_currency_id] = 0;
        paid_commission_amount[item.paid_commission_currency_id] =
          paid_commission_amount[item.paid_commission_currency_id] +
          item.paid_commission_amount;

        // add amount or exchange currency to used list
        if (item.currency_id) currencies[item.currency_id] = item.currency_id;
        if (item.receiver_currency_id)
          currencies[item.receiver_currency_id] = item.receiver_currency_id;
        if (item.commission_currency_id)
          currencies[item.commission_currency_id] = item.commission_currency_id;
        if (item.paid_commission_currency_id)
          currencies[item.paid_commission_currency_id] =
            item.paid_commission_currency_id;
      });
      return {
        amount,
        exchanged,
        currencies,
        commission_amount,
        paid_commission_amount,
      };
    },

    can() {
      return {
        add: this.userCan("add_transfers"),
        view: this.userCan("view_transfers"),
        edit: this.userCan("edit_transfers"),
        delete: this.userCan("delete_transfers"),
        any:
          this.userCan("edit_transfers") ||
          this.userCan("view_transfers") ||
          this.userCan("delete_transfers"),
      };
    },
    headers: (vm) => [
      {
        sortable: false,
        width: "30px",
        value: "index",
        hidePrint: true,
        text: vm.$t("number"),
      },
      {
        value: "number",
        text: vm.$t("tr"),
      },
      {
        value: "type",
        text: vm.$t("type"),
      },
      {
        sortable: false,
        value: "sender.name",
        text: vm.$t("sender"),
      },
      {
        sortable: false,
        value: "receiver.name",
        text: vm.$t("receiver"),
      },
      {
        value: "amount",
        sortable: false,
        text: vm.$t("amount"),
        computed: (item) => `${item.amount} ${vm.smbl(item.currency_id)}`,
      },
      // {
      //   value: "rate",
      //   width: "30px",
      //   sortable: false,
      //   text: vm.$t("rate"),
      // },
      // {
      //   sortable: false,
      //   value: "exchanged",
      //   text: vm.$t("total"),
      //   computed: (item) =>
      //     `${item.exchanged} ${vm.smbl(item.receiver_currency_id)}`,
      // },
      {
        sortable: false,
        text: vm.$t("commission"),
        value: "commission_amount",
        computed: (item) =>
          `${item.commission_amount} ${vm.smbl(item.commission_currency_id)}`,
      },
      {
        sortable: false,
        text: vm.$t("paid_commission"),
        value: "paid_commission_amount",
        computed: (item) =>
          `${item.paid_commission_amount} ${vm.smbl(
            item.paid_commission_currency_id
          )}`,
      },
      {
        width: "400px",
        sortable: false,
        value: "description",
        text: vm.$t("description"),
      },
      {
        value: "date",
        width: "120px",
        sortable: false,
        text: vm.$t("date"),
        computed: (item) => vm.persianDateFilter(item.date),
      },
      {
        value: "time",
        width: "120px",
        sortable: false,
        text: vm.$t("time"),
        computed: (item) => vm.persianDateFilter(item.date),
      },
      {
        align: "center",
        sortable: false,
        text: vm.$t("status"),
        computed: (item) => (item.done == 1 ? "Paid" : "Not Paid"),
      },
      {
        sortable: false,
        value: "actions",
        hidePrint: true,
        text: vm.$t("actions"),
      },
    ],
  },
  methods: {
    initData() {
      this.axios
        .get(`transfers?&type=${this.type}&date=${this.transfer.date}`)
        .then((resp) => {
          this.items = resp.data.data;
        });
    },

    saved(payload) {
      this.editDialog = false;
      if (this.editIndex < 0) this.computedItems.push(payload);
      else this.computedItems.splice(this.editIndex, 1, payload);
      this.$emit("saved", payload);
      this.reset();
    },

    showTransfer(item) {
      this.showItem = {
        transfer: item,
        sender: item.sender,
        receiver: item.receiver,
      };
      this.dialog = true;
    },

    printTable(excel) {
      let footers = [];
      for (let currency in this.summery.currencies) {
        footers.push(`
          <td colspan="5" class="px-2 font-weight-bold lr--text">${this.$t(
            "total"
          )} ${this.smbl(currency)}</td>
          <td  class="px-2 font-weight-bold">${
            this.summery.amount[currency]
          } ${this.smbl(currency)}</td>
          <td class="px-2 font-weight-bold">${
            this.summery.commission_amount[currency]
          } ${this.smbl(currency)}</td>
          <td class="px-2 font-weight-bold lr--text">${
            this.summery.paid_commission_amount[currency]
          } ${this.smbl(currency)}</td>
          <td colspan="100%" class="px-2 font-weight-bold lr--text">
          ${
            curjs(this.summery.commission_amount[currency]).subtract(this.summery.paid_commission_amount[currency])
          } ${this.smbl(currency)}</td>
        `);
      }
      let data = {
        footers,
        landscape: true,
        title: "Account Transfers",
        items: this.$refs.tbl.filteredItems,
        headers: this.headers.filter((x) => !x.hidePrint),
      };

      if (excel) return this.xl_tables(data, "transfers", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  async mounted() {
    if (this.initList) this.initData();
  },
};
</script>
